<template>
    <div class="employees">
        <router-view />
    </div>
</template>
